import React, { useMemo } from 'react';
import { calculateAdditionalPregnancyWeight } from '../utils/common';

const useAdditionalWeightInPregnancy = ({
	weighBeforePregnancy = '',
	actualWeight = '',
}) => {
	const additionalWeightInPregnancy = useMemo(
		() =>
			calculateAdditionalPregnancyWeight({
				weighBeforePregnancy,
				actualWeight,
			}),
		[weighBeforePregnancy, actualWeight],
	);

	return {
		additionalWeightInPregnancy: additionalWeightInPregnancy
			? String(Number(additionalWeightInPregnancy).toFixed(1))
			: '',
	};
};

export default useAdditionalWeightInPregnancy;
